import { render, staticRenderFns } from "./ChooseVolunteers.vue?vue&type=template&id=82e4f1da&scoped=true&"
import script from "./ChooseVolunteers.vue?vue&type=script&lang=js&"
export * from "./ChooseVolunteers.vue?vue&type=script&lang=js&"
import style0 from "./ChooseVolunteers.vue?vue&type=style&index=0&id=82e4f1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e4f1da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCheckbox,VContainer,VFlex,VForm,VIcon,VLayout,VTextarea,VTooltip})
